import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import * as feather from 'feather-icons';
import * as _ from 'lodash';
import { Competency } from 'src/app/common/models/competency';
import { CompetencyService } from 'src/app/common/services/competency.service';
import { UserService } from 'src/app/common/services/user.service';
import { ConfirmDialog, ConfirmationDialogComponent } from 'src/app/dialogs/dialog-unsaved-changes/confirmation-dialog.component';

@Component({
    selector: 'app-set-priorities',
    templateUrl: './set-priorities.component.html',
    styleUrls: ['./set-priorities.component.css'],
    standalone: false
})
export class SetPrioritiesComponent implements AfterViewChecked, OnInit {

  @Input() competencies: Competency[];
  @Input() savedCompetencies: Competency[];
  @Output() priorityCompetencyChange = new EventEmitter();
  @Output() toggleButton = new EventEmitter();

  @ViewChild("errorSection", {read: ElementRef}) errorSection!: ElementRef;

  showMinCompetencyError = false;
  showMaxCompetencyError = false;

  constructor(private cdr: ChangeDetectorRef, private competencyService: CompetencyService, private userService: UserService, private dialog: MatDialog){}

  ngAfterViewChecked(){
    feather.replace();
  }

  ngOnInit(){
    this.showMaxCompetencyError = false;
    this.showMinCompetencyError = false;
  }

  order(index: number, up: boolean, button: HTMLButtonElement) {
    if (up) {
      if (index !== 0) {
        const temp = this.competencies[index - 1];
        this.competencies[index - 1] = this.competencies[index];
        this.competencies[index] = temp;
        this.cdr.detectChanges();
        button.focus();
      }
    }
    else {
      if (index !== this.competencies.length) {
        const temp = this.competencies[index + 1];
        this.competencies[index + 1] = this.competencies[index];
        this.competencies[index] = temp;
        this.cdr.detectChanges();
      }
    }
    this.toggleButton.emit(true);
    this.competencyService.updateCompetencyPriority(this.competencies).subscribe(() => {
      this.toggleButton.emit(false);
    })
  }

  //todo: REFACTOR create single component
  saveForLater(competency: Competency, bypassSaveDialog: boolean) {

    const nonOtherCompetencyCount = this.competencies?.filter(r => r.Domain !== "Other")?.length;

    if (nonOtherCompetencyCount <= 2 && competency.Domain !== "Other") {
      this.showMinCompetencyError = true;
    } else if ((nonOtherCompetencyCount > 2 || competency.Domain === "Other") && this.savedCompetencies?.length < 15) {
      this.showMinCompetencyError = false;
      this.showMaxCompetencyError = false;
      if (!bypassSaveDialog)
        this.openSaveDialog(competency);
      else {
        this.saveCompetencyForLater(competency);
      }
    } else if (this.savedCompetencies?.length >= 15) {
      this.renderMaxSaveForLaterCompetencyError();
    }
  }

  //todo: REFACTOR create single component
  remove(competency: Competency) {
    const nonOtherCompetencyCount = this.competencies?.filter(r => r.Domain !== "Other")?.length;

    if (nonOtherCompetencyCount <= 2 && competency.Domain !== "Other") {
      this.showMinCompetencyError = true;
    } else if ((nonOtherCompetencyCount > 2 || competency.Domain === "Other") && this.savedCompetencies?.length < 15) {
      this.showMaxCompetencyError = false;
      this.showMinCompetencyError = false;
      this.openRemoveDialog(competency);
    } else if (this.savedCompetencies?.length >= 15) {
      this.renderMaxSaveForLaterCompetencyError();
    }
  }


  openSaveDialog(competency: Competency) {
    const confirm = new ConfirmDialog();
      confirm.title = "Save for Later?";
      confirm.message = "Are you sure you want to remove this competency from this year’s plan and save it for later?";
      confirm.message2 = ""
      confirm.okButtonTitle = "OK";
      confirm.cancelButtonTitle = "Cancel";
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '425px',
        height: '275px',
        data: confirm,
        disableClose: false,
        ariaLabelledBy: 'confirm-desc'
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'ok') {
          this.saveCompetencyForLater(competency);
        }
      });
  }

  openRemoveDialog(competency: Competency){
    const confirm = new ConfirmDialog();
      confirm.title = "Remove Competency from Plan?";
      confirm.message = "Are you sure you want to remove this competency?";
      confirm.message2 = "Your self-assessment, notes, reflections, and any progress tracked for this competency and its learning activities will be removed from your plan."
      confirm.message3 = "You can also return this competency to your list of saved competencies.";
      confirm.okButtonTitle = "Remove";
      confirm.thirdButtonTitle = "Save for Later"
      confirm.cancelButtonTitle = "Cancel";
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '425px',
        height: '460px',
        data: confirm,
        disableClose: true,
        ariaLabelledBy: 'confirm-desc'
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'ok') {
          this.userService.user().subscribe({next: () => {
            this.competencyService.deleteCompetency(competency).subscribe({next: () => {
              _.remove(this.competencies, function (n) { return n.Id === competency.Id });
              //_.remove(this.competencies, function (n) { return n.Id === competency.Id });
            }});
          }});
        }
        else if (result === 'third'){
          this.saveForLater(competency, true);
        }
      });
  }

  saveCompetencyForLater(competency: Competency){
    this.userService.user().subscribe({next: (user) => {
      competency.UserId = user.Id;
      competency.PlanId = '0';
      this.competencyService.updateCompetencyByUserId(competency).subscribe({next: (competency) => {
        _.remove(this.competencies, function (n) { return n.Id === competency.Id });
        //_.remove(this.workingCompetencies, function (n) { return n.Id === competency.Id });
        this.savedCompetencies.push(competency);
      }});
    }});
  }

  //todo: Refactor steps save for later and remove components
  private renderMaxSaveForLaterCompetencyError() {
    this.showMaxCompetencyError = true;
    this.cdr.detectChanges();
    //wait for DOM to render and then scroll to element
    setTimeout(() => {
      if (this.errorSection?.nativeElement) {
        this.errorSection.nativeElement.scrollIntoView({block: "center"});
      }
    }, 0);
  }
}
